<template>
    <div class="container px-2 px-lg-4">
        <BaseHeader :title="title">
        </BaseHeader>
        <BaseFilter removeSearchBar>
            <div class="item action btn-group">
                <baseButton class="btn-filter btn-success w-100" data-bs-toggle="dropdown" ariahashpopup="true" aria-expanded="true" data-bs-auto-close="outside">
                    <font-awesome-icon icon="far fa-filter" />
                    Filtros
                    <span class="filters_qty_active">{{ totalFilters }}</span>
                </baseButton>
                <div class="dropdown-menu dropdown-menu-end py-0"  aria-labelledby="dropdownMenu">
                    <FilterReferrals @filters="filters" :initialFilters="initialFilters" @filtersQty="filtersQty"/>
                </div>
                <baseButton class="btn-success w-100 dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                    Exportar
                </baseButton>
                <div class="dropdown-menu" x-placement="bottom-start" aria-labelledby="dropdownMenu">
                    <a class="dropdown-item d-flex justify-content-center flex-column" target="_blank" :href="exportUrl + 'csv' + exportParams">CSV</a>
                    <a class="dropdown-item d-flex justify-content-center flex-column" target="_blank" :href="exportUrl + 'xls' + exportParams">XLS</a>
                </div>
            </div>
        </BaseFilter>
        <BaseTable class="no_top_radius" :columns="tableColumns" :paginate="paginate" :isLoading="isLoading" :qty="products.length"  @changePage="changePage" :noActions="true">
            <tr v-for="(product, key) in reportStore.products" :key="key">
                <td width="35%">{{ product.title }}</td>
                <td>{{ product.type }}</td>
                <td><BaseStoreDot :color="product.store.color" :title="product.store.title" /></td>
                <td>{{ product.qty }}</td>
                <td>{{ globalStore.formatMoney(product.amount) }}</td>
            </tr>
            <tr v-if="products.length">
                <td class="bold" colspan="3">Total</td>
                <td class="bold">{{ reportStore.getTotalProductsQty() }}</td>
                <td class="bold">{{ globalStore.formatMoney(reportStore.getTotalProductsAmount()) }}</td>
            </tr>
        </BaseTable>
    </div>
</template>
<script setup>
const title = {title: 'Relatório: Produtos vendidos', icon: 'fa-chart-simple'};
import FilterReferrals from '@/components/includes/reports/ReportsFilter';

import { ref, onBeforeMount, watch } from 'vue';
import { storeToRefs } from 'pinia';
import qs from "qs";

import { useReportStore } from '@/stores/report';
const reportStore = useReportStore();
const { products, paginate } = storeToRefs(reportStore);

import { useGlobalStore } from '@/stores/global';
const globalStore = useGlobalStore();
const { defaultStore } = storeToRefs(globalStore);

const tableColumns = ['Produto', 'Tipo', 'Loja', 'Quantidade', 'Valor'];

const isLoading = ref(false);

import { useRouter, useRoute } from 'vue-router';
import BaseFilter from '@/components/ui/BaseFilter.vue';
const route = useRoute();
const router = useRouter();

let initialFilters = null;

onBeforeMount(() => {
    if(!globalStore.hasPermissionTo('report_products')) {
        return router.push('/403');
    }

    if(reportStore.products.length == undefined){
        isLoading.value = true;
    }

    if(route.query.page || route.query.date_start || route.query.date_end) {
        Object.keys(reportStore.products_rep_filters).forEach((key) => {
            let currentThing = route.query[key];
            reportStore.products_rep_filters[key] = '';
            reportStore.products_rep_filters[key] = currentThing;
            
            initialFilters = reportStore.products_rep_filters;
            let param = route.query[key];
            reportStore.products_rep_filters[key] = (param == undefined) ? null : param;

        });
    }

    loadProducts().then(() => {
        isLoading.value = false;
    });

    if(reportStore.products_rep_filters.date_start && reportStore.products_rep_filters.date_end){
        initialFilters = {};
        initialFilters['date_range'] = reportStore.products_rep_filters.date_start + '@' + reportStore.products_rep_filters.date_end
    }

});

let isChangingPage = false;
async function changePage(page) {
    if(isChangingPage) return;
    reportStore.products_rep_filters.page = page;
    globalStore.loader('show');
    isChangingPage = true;
    loadProducts().then(() => {
        isChangingPage = false;
        window.scrollTo({ top:0, left:0, behavior: "instant"});
    });
}

// eslint-disable-next-line
const exportUrl = ref(process.env.VUE_APP_API_URL + 'reports/products/export/');

const exportParams = ref('');

let loadDefaultStore = false;
watch(defaultStore, function () {
    if(!loadDefaultStore) {
        loadDefaultStore = true;
        reportStore.products_rep_filters.page = null;
        globalStore.loader('show');
        loadProducts().then(()=> {
            globalStore.loader('hide');
            loadDefaultStore = false;
        });
    }
});

async function loadProducts() {
    let usedParams = {};
    if(initialFilters){
        initialFilters.date_range = null
    }
    
    Object.keys(reportStore.products_rep_filters).forEach((key) => {
        if(reportStore.products_rep_filters[key] != null && reportStore.products_rep_filters[key] != '') {

            let currentParams = {
                ...usedParams,
                [key]: reportStore.products_rep_filters[key]
            };
            usedParams =  currentParams;
        }
    });

    router.replace({query: usedParams});
    exportParams.value = (usedParams) ? '?' + qs.stringify(usedParams, { arrayFormat: "brackets" }) : '';
    await reportStore.tryProducts(reportStore.products_rep_filters);
    globalStore.loader('hide');
}

const totalFilters = ref(0);

function filtersQty(r) {
    totalFilters.value = r;
}

function filters(r) {
    Object.keys(r).forEach((key) => {
        reportStore.products_rep_filters[key] = r[key];
    });
    globalStore.loader('show');
    loadProducts();
}

</script>

<style scoped>

.filters_qty_active{
    background-color: #7ad563;
    padding: 0px 6px;
    font-size: 12px;
    color: white;
    border-radius: 40px;
    margin-left: 9px;
}

.base-title .action {
    flex: 0 0 225px!important;
}

.btn-filter{
    margin-right: 10px;
}

.btn-filter::after {
    display: none !important;
}

.bold{
    font-weight: bold; 
}

</style>